import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Extended twMerge that treats all `enki-*` classes as one conflict group,
 * so later passed className can override base enki-* (e.g. enki-body-2xs) with another enki-* (e.g. enki-body-sm).
 */
export const twMerge = extendTailwindMerge({
  classGroups: {
    'enki-typography': [{ enki: [(_: string) => true] }]
  }
});
